// JS
import { BASE_URL } from './constants.js'

function handleRestResponse(response) {
  if (response.status >= 200 && response.status < 300) {
    return Promise.resolve(response.json())
  } else {
    let error = {
      'message': 'Something went wrong, please try again later',
      'response': response
    }

    return Promise.reject(error)
  }
}

/**
 * Fetch projects from the backend
 */
export function fetchProjectsFromBackend() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/projects/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch project from the backend
 */
export function fetchProjectFromBackend(url) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/projects/${url}/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch page from the backend
 */
export function fetchPageFromBackend(url) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/pages/${url}/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch projects from the backend
 */
export function fetchCategoriesFromBackend() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/categories/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch all news from the backend
 */
export function fetchAllNewsFromBackend() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/news/`, options)
    .then(handleRestResponse)
    .then((response) => response)
}

/**
 * Fetch news from the backend
 */
export function fetchNewsFromBackend(url) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/news/${url}/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch all reviews from the backend
 */
export function fetchAllReviewsFromBackend() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/reviews/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch review from the backend
 */
export function fetchReviewFromBackend(url) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/reviews/${url}/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch all exhibitions from the backend
 */
export function fetchAllExhibitionsFromBackend() {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/exhibitions/`, options)
    .then(handleRestResponse)
}

/**
 * Fetch exhibition from the backend
 */
export function fetchExhibitionFromBackend(url) {
  const options = {
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  }

  return fetch(`${BASE_URL}/exhibitions/${url}/`, options)
    .then(handleRestResponse)
}


// WEBPACK FOOTER //
// ./src/utils/rest.js